import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { FlightsClassTypes } from 'constants/flight'
import useCharterFlightJourneysForHotelDates from 'hooks/CharterFlights/useCharterFlightJourneysForHotelDates'
import { getSeatsLeftFromJourney, hasInsufficientCharterSeats } from 'lib/charterFlights/charterFlightAvailability'
import { useSeatEligiblePassengers } from '../MaldivesDirectSearchPage/hooks/utils'
import { getMaldivesBundleCheckOutDate } from '../MaldivesDirectSearchPage/MaldivesDirectUtils'
import { ONE_POINT_PROMO_DATE } from './promoContent'

interface Params {
  rooms: Array<App.Occupants>
  duration: number
  disabled?: boolean
}

export default function useMaldivesOnePointPromoAvailability({ rooms, duration, disabled = false }: Params): boolean {
  const enabled = useFeatureFlag(OptimizelyFeatureFlags.flightsIncompleteCharterBundles)
  const seatEligiblePassengers = useSeatEligiblePassengers(rooms)
  const checkOutDate = getMaldivesBundleCheckOutDate(ONE_POINT_PROMO_DATE, duration) ?? undefined
  const { departingJourney, returningJourney, fetching, error } = useCharterFlightJourneysForHotelDates({
    charterBundleRoute: enabled && !disabled ? 'melbourne-maldives' : undefined,
    checkInDate: ONE_POINT_PROMO_DATE,
    checkOutDate,
    occupancies: rooms,
    fareClass: FlightsClassTypes.ECONOMY,
    disabled: !enabled || disabled,
  })

  return enabled && !disabled && !fetching && !error && seatEligiblePassengers > 0 &&
    !!departingJourney && !returningJourney &&
    !hasInsufficientCharterSeats(ONE_POINT_PROMO_DATE, checkOutDate, duration, getSeatsLeftFromJourney(departingJourney), seatEligiblePassengers)
}
